import { Time } from '@angular/common';
import { Component, Inject, Injector, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AppComponentBase } from '@shared/app-component-base';
import { ProductDto, ProductServiceProxy, ProductVariationStocksOutputDto } from '@shared/service-proxies/service-proxies';
import { forEach } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { ShoppingCardService } from '../services/shopping-card.service';
import { CustomLocalizationService } from '@app/views/pages/transpop/utility/customLocalization.service';

class productIdAndSumQty {
  totalProductVariationOrderQty: number;
  productId: number;
  
}


@Component({
  selector: 'kt-skt-lot-modal',
  templateUrl: './skt-lot-modal.component.html',
  styleUrls: ['./skt-lot-modal.component.scss']
})
export class SktLotModalComponent extends AppComponentBase implements OnInit {

	//desc = "Ürünün varyasyonuna göre stok miktarını görebilir ve talepte bulunabilirsiniz.";
	desc = this.localization.localize("FE.ORDER.FORMS.INFOALERTS.COMMON.VARIATIONORDERED", this.localizationSourceName);

	products = new BehaviorSubject<ProductDto[]>([]);
	totalStokNumber: number = 0;
	isTotalCount = new BehaviorSubject<boolean>(null);

	hideProductListByVariation = new BehaviorSubject<boolean>(false);
	//noVariationTotalStock;

	selectVariationProduct: ProductDto;
	orderedQty: number = 0;
	constructor(
		injector: Injector,
		private customLocalization: CustomLocalizationService,
	  private shoppingCardService: ShoppingCardService,
	  private _productService: ProductServiceProxy,
	  public dialogRef: MatDialogRef<SktLotModalComponent>,

		@Inject(MAT_DIALOG_DATA)
		public _data : any
  ) {

	  super(injector);
	  
   }

  ngOnInit() {
	  //this._data içerisinde tıklanan ütünün bilgileri geliyor.
	  console.log(this._data);
	  this.getProductVaritionStocks();
  }

	getProductVaritionStocks() {

		var obj = this._data;

		var productId = obj.productItems.id;
		var warehouseId = obj.selectWarehouseObj.id;
		var warehouseCode = obj.warehouseCode;
		//var remoteWarehouseId = obj.selectWarehouseObj.remoteWarehouseId;
		var specialCode = obj.specialCode;
		var brandsIds = obj.brandIds;
		var damageStatusType = obj.orderDamageStatus;

		this._productService.getProductVariationStocks(
			warehouseId,
			warehouseCode,
			//remoteWarehouseId,
			specialCode == "-1" ? "" : specialCode,
			brandsIds,
			damageStatusType,
			productId
		).subscribe((productList: ProductVariationStocksOutputDto) => {

			console.log("varyasyonluÜrünListesi" + productList);
			//üürn listesi sıfırda küçük ise bazı yerleri yani grid gizlemek ve infoyu göstermek
			//için kullanıyoruzç
			if (productList.products.length < 1) {
				return this.hideProductListByVariation.next(true);
			}
			//this.noVariationTotalStock = productList.noVariationTotalStock;

			//Sepet içerisinde tüm kayıtlı datalrı getir diyoruz.
			var registeredProductData = this.shoppingCardService.getItems().getValue();

			//Arka taraftan dönen varyasyonlu ürünün içerisinde geziyoruz
			//sepet içerisin de o ürün ve varyasyon da bir kayıt varsa qty sini ürün listesinde ki ilgli varyasyon içerisine setliyoruz.
			productList.products.forEach(product => {
				console.log(product);
				let registerData = registeredProductData.find(x => x.id == product.id && x.variationId == product.variationId);
				if (registerData) {

					this.selectVariationProduct = product;
					this.orderedQty = registerData.orderedQty;

					//eski hali
					//product.orderedQty = registerData.orderedQty;

				}

			});


			this.products.next(productList.products);
		})

	}

	// //bir talep girilip o textbox dan çıkıldığı anda girilen talep adedini alır ve sorgular
	// //eğer stok adedinden ya da total talep adedinden büyük ise hata dönderir ve değeri sıfırlarız.
	// onBlurStokControlByOrderedQty(selectProduct: ProductDto) {

	// 	console.log("stok görme yetkisi kontrolu:" + this._data.stokView);
	// 	//stok görme yetkisi yok ise stok kontrolu yaptırmıyoruz.
	// 	if (!this._data.stokView) {
	// 		return;

	// 	}

	// 	var qty = selectProduct.orderedQty;
	// 	var stok = selectProduct.stok;

	// 	//ana gridde ki tıklanan ürünün stok adedidir.
	// 	var totalStok = this._data.productItems.stok;

	// 	//varyasyonlu ürün listesinden qty sıfırdan büyük olanaların map methodu ile sadece qty miktarlarını al ve reduce ile toplamları bize dönder diyoruz.
	// 	var currentTotalQty = this.products.getValue()
	// 									.filter(x => x.orderedQty > 0)
	// 											.map(y => y.orderedQty).reduce((a, b) => {
	// 													return (+a) + (+b);
	// 												});

	// 	//Girilen qty miktarı ana gridden gelen total qty miktarında fazla ise
	// 	//hata verdir ve qty miktarını sıfıra çek diyoruz.
	// 	if (currentTotalQty > totalStok) {

	// 		//ön tarafta total adedin geçildiğini kullanıcıya göstermek için border göstermek amaçlı eklendi
	// 		this.isTotalCount.next(true);
	// 		selectProduct.orderedQty = 0;

	// 		return this.uiMessage.modal.warning("Stok Hatası", "Talep Adedi Stoktan Büyük Olamaz!", () => {
	// 			this.isTotalCount.next(false);

	// 		});
	// 	}


	// 	//girdiği stok adedi stok tan büyükse talep adedini sıfırla diyoruz
	// 	//ana grid deki tıklanan ürünün stok adedi modal içerisinde varyasyonlu
	// 	//ürünlerin içerisine girilen talep adetlerinin toplamında küçük ise gir diyoruz.
	// 	if (qty > stok){

	// 		selectProduct.orderedQty = 0;
	// 		return this.uiMessage.modal.warning("Stok Hatası", "Talep Adedi Stoktan Büyük Olamaz!",null);
	// 	}
		
	// }

//   //Kaydet me işlemi yapıldığı anda stok ları kaydediriz
//   onClickSave(){

// 	//Ürün listesin de girilmiş olan talep adetlerini alıyorum.
//     var selectProducts = this.products.getValue().filter(x => x.orderedQty > 0);

//     if(selectProducts.length < 1){
//       return this.uiMessage.modal.warning("","En az bir tane stok adedi girmeden kaydet yapamazsınız.",null);
//     }

// 	//o ürüne ait tüm kayıtları siler. Sepet içerisinden
// 	this.shoppingCardService.removeProductByProductId(this._data.productItems.id);
//     //this.shoppingCardService.removeProductByVariationId(this._data.productItems.id);

// 	 var sumQty: number = 0;

//     selectProducts.forEach(product => {
//       var obj = new ProductDto();      
// 		obj.id = this._data.productItems.id;
// 		obj.variationId = product.variationId;
// 		obj.orderedQty = product.orderedQty;

// 	  //girilen talep adetlerinin toplamını alıuyoruz.
// 		sumQty = sumQty + (+obj.orderedQty);

// 	  //sepet içerisine ekleme işlemini yapıyoruz	
// 		this.shoppingCardService.addToCart(obj)

//     });
//     var productIdAndSumQtyObj = new productIdAndSumQty();

//     productIdAndSumQtyObj.productId = this._data.productItems.id;
//     productIdAndSumQtyObj.totalProductVariationOrderQty = sumQty;

//     this.dialogRef.close(productIdAndSumQtyObj);
//   }


	//bir talep girilip o textbox dan çıkıldığı anda girilen talep adedini alır ve sorgular
	//eğer stok adedinden ya da total talep adedinden büyük ise hata dönderir ve değeri sıfırlarız.
	onBlurStokControlByOrderedQty() {

		console.log("stok görme yetkisi kontrolu:" + this._data.stokView);
		//stok görme yetkisi yok ise stok kontrolu yaptırmıyoruz.
		if (!this._data.stokView) {
			return;

		}

		var selectStok = this.selectVariationProduct.stok;
		var selectOrderedQty = this.orderedQty;
		//girdiği stok adedi stok tan büyükse talep adedini sıfırla diyoruz
		//ana grid deki tıklanan ürünün stok adedi modal içerisinde varyasyonlu
		//ürünlerin içerisine girilen talep adetlerinin toplamında küçük ise gir diyoruz.
		if (selectStok < selectOrderedQty){

			this.orderedQty = 0;
			return this.uiMessage.modal.warning(this.customLocalization.l("FE.ALERTMESSAGES.STOCK.HEADER"), this.customLocalization.l("FE.ALERTMESSAGES.STOCK.OVERSTOCK"), null);
		}
		
	}

  	//change işlemi olduğu anda talep miktarını sıfırlamalıyız.
	onChangeVariationProduct(){

		this.orderedQty = 0;

	}

 //Kaydet me işlemi yapıldığı anda stok ları kaydediriz
 onClickSave(){

	if(this.orderedQty < 1){
		return this.uiMessage.modal.warning("", this.customLocalization.l("FE.ALERTMESSAGES.STOCK.MINIMUMORDERCOUNT"),null);
	}
	else if(!this.selectVariationProduct){
		return this.uiMessage.modal.warning("", this.customLocalization.l("FE.ALERTMESSAGES.STOCK.EXPIRATIONDATELOTMODAL.VARIATIONISREQUIRED"),null);

	}

	this.selectVariationProduct.orderedQty = this.orderedQty;
	//o ürüne ait tüm kayıtları siler. Sepet içerisinden
	this.shoppingCardService.removeProductByProductId(this._data.productItems.id);
    //this.shoppingCardService.removeProductByVariationId(this._data.productItems.id);

	  var sumQty: number = 0;

      var obj = new ProductDto();      
		obj.id = this._data.productItems.id;
		obj.variationId = this.selectVariationProduct.variationId;
		obj.orderedQty = this.selectVariationProduct.orderedQty;

		obj.lot = this.selectVariationProduct.lot ? this.selectVariationProduct.lot : null;
		obj.barcode = this.selectVariationProduct.barcode ? this.selectVariationProduct.barcode : null;
		obj.expirationDate = this.selectVariationProduct.expirationDate ? this.selectVariationProduct.expirationDate : null;
		obj.name = this.selectVariationProduct.name;
		obj.kod = this.selectVariationProduct.kod;
		obj.wmsTip = this.selectVariationProduct.wmsTip;
		// obj.stok = this.selectVariationProduct.stok ? this.selectVariationProduct.stok : 0; 
	  //girilen talep adetlerinin toplamını alıuyoruz.
		sumQty = sumQty + (+obj.orderedQty);

	  //sepet içerisine ekleme işlemini yapıyoruz	
		this.shoppingCardService.addToCart(obj)

    var productIdAndSumQtyObj = new productIdAndSumQty();

    productIdAndSumQtyObj.productId = this._data.productItems.id;
    productIdAndSumQtyObj.totalProductVariationOrderQty = sumQty;

    this.dialogRef.close(productIdAndSumQtyObj);
  }

  close(){

    this.dialogRef.close();
  }
}
